// extracted by mini-css-extract-plugin
export default {"edit-alerts":"edit-alerts_edit-alerts__eCk7K"};